export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="site-footer__rule" aria-hidden />
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <img
            src="/images/WIC_Logo_grey.png"
            alt="WIC"
            className="site-footer__logo"
          />
        </div>

        <div className="site-footer__meta">
          <p>Western Industrial Contractors</p>
          <p>Aurora, CO &middot; (303) 371-3714</p>
          <p>
            <a href="https://westerncon.com" target="_blank" rel="noopener noreferrer">westerncon.com</a>
          </p>
        </div>

        <div className="site-footer__legal">
          <p>&copy; {year} Western Industrial Contractors</p>
          <p className="caption">Internal event hub &middot; for WIC employees and guests</p>
        </div>
      </div>

      <style>{`
        .site-footer {
          margin-top: var(--section);
          background: var(--white);
        }
        .site-footer__rule {
          height: 4px;
          background: var(--red);
        }
        .site-footer__inner {
          max-width: 1400px;
          margin: 0 auto;
          padding: 3rem var(--gutter);
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 2rem;
          align-items: start;
        }
        .site-footer__brand { display: flex; flex-direction: column; gap: 0.4rem; align-items: flex-start; }
        .site-footer__logo { height: 52px; width: auto; max-width: 200px; object-fit: contain; }
        
        .site-footer__meta p,
        .site-footer__legal p {
          margin: 0 0 0.4rem 0;
          font-size: 0.9rem;
          color: var(--mid);
        }
        .site-footer__legal {
          text-align: right;
        }
        @media (max-width: 720px) {
          .site-footer__inner {
            grid-template-columns: 1fr;
            gap: 2rem;
            padding: 2.5rem var(--gutter);
          }
          .site-footer__legal { text-align: left; }
        }
      `}</style>
    </footer>
  );
}
